import React from 'react'
import {Select, FormControl, InputLabel, MenuItem} from '@material-ui/core'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty, isUndefined} from 'lodash'
import {onGetKontoPrislistor} from 'actions'
import IntlMessages from 'util/IntlMessages';
export default function Prislista(props) {
  const dispatch = useDispatch()

  const KundPrisListor = useSelector(state => state.accountsData.KundPrisListor)
  const KundFornoxPrislist = useSelector(state => state.accountsData.KundFornoxPrislist)
  const auth = useSelector(state => state.auth.authUser)

  React.useEffect(() => {
    dispatch(onGetKontoPrislistor(auth.user_Afid))
  }, [])
  React.useEffect(() => {
    if(isUndefined(props.isFrom)){
    if(!isEmpty(KundPrisListor)){
        console.log(props,"PrisListId")
      let prislistaValue = KundPrisListor.filter(item=> parseInt(item.isDefault) === 1)[0].id
      let prislistaisFortnox = KundPrisListor.filter(item=> parseInt(item.isDefault) === 1)[0].isFortnox
      
      props.onChange({target:{
        name:"PrisListId",
        value:parseInt(props.PrisListId)!==0?props.PrisListId:parseInt(prislistaisFortnox) !== 0?KundFornoxPrislist===0?prislistaValue:KundFornoxPrislist:prislistaValue
      }})
    }
  }
  },[props.PrisListId,KundPrisListor,KundFornoxPrislist])
  console.log(KundFornoxPrislist,"DDDDD")
  console.log(props,"KundKunde")
  if(KundPrisListor.length < 2) return ''
  return (
    <FormControl variant="outlined" className={'w-100'}
      size="small">
      <InputLabel id="kategori-label" error={props.errorMall}><IntlMessages id="input.Price.list"/></InputLabel>
      <Select
        labelId="kategori-label"
        id="kategori"
        label={<IntlMessages id="input.Price.list"/>}
        name="PrisListId"
        disabled={isUndefined(props.permission)?false:parseInt(props.permission) !==2}
        onChange={props.onChange}
        value={props.PrisListId}
      >
        {
            !isEmpty(KundPrisListor) && KundPrisListor.map((item, index)=> (
                <MenuItem key={index} value={item.id}>{item.Name}</MenuItem>
            ))
            }
        
      </Select>
    </FormControl>
  )
}
